module.exports = __webpack_public_path__ + "static/media/delete_icon.e6d0b789.svg";